import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessControl } from './access-control';
import { AuthService } from './auth.service';

/**
 * Allows a route only for users with the `hickory.enterprise-dashboard` permission; otherwise redirects home. Loads
 * the user first if needed, so it also works on a page refresh.
 */
export const enterpriseDashboardGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return (await auth.checkPermissions([AccessControl.FeatureEnterpriseDashboard])) || router.parseUrl('/');
};
